module.exports = __webpack_public_path__ + "Participant Notice 08_28_2024.pdf";